import { render, staticRenderFns } from "./AccountHeadsAdd.vue?vue&type=template&id=518f15e6&"
import script from "./AccountHeadsAdd.vue?vue&type=script&lang=js&"
export * from "./AccountHeadsAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports